import data from "../../../configs/data";
import {Button} from "../../../controlElements/Button";
import {ObservableContainer} from "../../../controlElements/ObservableContainer";
import {DeviceDetector} from "../../../DeviceDetector";
import {EuropeanRoulette} from "../../../EuropeanRoulette";

export class SplitBetsPanel extends ObservableContainer {

    public static readonly POSSIBLE_SPLIT_BETS: Array<Array<number>> = [
        [0, 1],
        [0, 2],
        [0, 3],
        [1, 4],
        [2, 5],
        [3, 6],
        [4, 7],
        [5, 8],
        [6, 9],
        [7, 10],
        [8, 11],
        [9, 12],
        [10, 13],
        [11, 14],
        [12, 15],
        [13, 16],
        [14, 17],
        [15, 18],
        [16, 19],
        [17, 20],
        [18, 21],
        [19, 22],
        [20, 23],
        [21, 24],
        [22, 25],
        [23, 26],
        [24, 27],
        [25, 28],
        [26, 29],
        [27, 30],
        [28, 31],
        [29, 32],
        [30, 33],
        [31, 34],
        [32, 35],
        [33, 36],
        [1, 2],
        [2, 3],
        [4, 5],
        [5, 6],
        [7, 8],
        [8, 9],
        [10, 11],
        [11, 12],
        [13, 14],
        [14, 15],
        [16, 17],
        [17, 18],
        [19, 20],
        [20, 21],
        [22, 23],
        [23, 24],
        [25, 26],
        [26, 27],
        [28, 29],
        [29, 30],
        [31, 32],
        [32, 33],
        [34, 35],
        [35, 36],
    ];

    private buttons: Array<Button> = [];
    /**
     * Must be the same as on the server
     * @type {number[][]}
     */

    constructor(straightBetsButtonsOffsetX: number,
                straightBetsButtonsOffsetY: number,
                straightBetsOffsetFromZero: number) {
        super();
        this.createAndAddBetsButtons(
            straightBetsButtonsOffsetX,
            straightBetsButtonsOffsetY,
            straightBetsOffsetFromZero);
    }

    public getButtonPosition(number: number): PIXI.Point {
        return (this.buttons[number].position as PIXI.Point);
    }

    private createAndAddBetsButtons(straightBetsButtonsOffsetX: number,
                                    straightBetsButtonsOffsetY: number,
                                    straightBetsOffsetFromZero: number): void {

        let columnCurrentIndex = 0;
        for (let index = 0; index < EuropeanRoulette.ROULETTE_MAXIMUM_NUMBER; index++) {
            const row = 2 - (index % 3);
            const button = new Button(data.images.regularNumberBaseState, data.images.regularNumberBaseState,
                data.images.regularNumberBaseState, data.images.regularNumberHoverDisableState);

            this.initializeBetButtonBehavior(button, index);
            button.position.x = straightBetsOffsetFromZero - straightBetsButtonsOffsetX / 2 +
                columnCurrentIndex * straightBetsButtonsOffsetX;
            button.position.y = row * straightBetsButtonsOffsetY;
            this.buttons.push(button);
            this.addChild(button);
            if (row === 0) {
                columnCurrentIndex++;
            }
        }

        columnCurrentIndex = 0;

        for (let index = EuropeanRoulette.ROULETTE_MAXIMUM_NUMBER;
             index < EuropeanRoulette.ROULETTE_MAXIMUM_NUMBER * 5 / 3; index++) {
            const row = 1 - (index % 2);
            const button = new Button(data.images.regularNumberBaseState, data.images.regularNumberBaseState,
                data.images.regularNumberBaseState, data.images.regularNumberHoverDisableState);

            this.initializeBetButtonBehavior(button, index);
            button.position.x = straightBetsOffsetFromZero + columnCurrentIndex * straightBetsButtonsOffsetX;
            button.position.y = row * straightBetsButtonsOffsetY + straightBetsButtonsOffsetY / 2;
            this.buttons.push(button);
            this.addChild(button);
            if (row === 0) {
                columnCurrentIndex++;
            }
        }
    }

    private onValueChosen(index: number): void {
        this.callOnClickedSubscribers(index, SplitBetsPanel.POSSIBLE_SPLIT_BETS[index]);
    }

    private onHover(index: number): void {
        this.callOnPointerDownSubscribers(index, SplitBetsPanel.POSSIBLE_SPLIT_BETS[index]);
    }

    private onHoverOutside(index: number): void {
        this.callOnPointerUpSubscribers(index, SplitBetsPanel.POSSIBLE_SPLIT_BETS[index]);
    }

    private initializeBetButtonBehavior(button: Button, thisArg: any): void {
        button.subscribeOnClicked(this.onValueChosen.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_DOWN, this.onHover.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_CANCEL, this.onHoverOutside.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_OVER, this.onHover.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_OUT, this.onHoverOutside.bind(this, thisArg));
        if (DeviceDetector.isMobileOrTabletDevice()) {
            button.on(Button.BUTTON_EVENTS.POINTER_UP, this.onHoverOutside.bind(this, thisArg));
            button.on(Button.BUTTON_EVENTS.POINTER_UP_OUTSIDE, this.onHoverOutside.bind(this, thisArg));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/rouletteBetsPanel/implementations/SplitBetsPanel.ts